import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import Reveal from "./Reveal";

const REVIEWS = [
  { name: "Dali R.", text: "Communication was prompt and clear from start to finish and the job was completed quickly and efficiently. The plumber and electrician who attended were professional, polite and very helpful, making the whole process smooth and stress free. Highly recommend!" },
  { name: "Ela S.", text: "I've used them quite a few times over a couple of years at my place as well as my daughter's. Some smaller and some bigger jobs. Always a very good job in every way and best prices compared with others. Can't thank them enough." },
  { name: "Nicola Ryan", text: "I cannot recommend this company highly enough. The service was timely and gold standard. The tradesmen were efficient, did an outstanding job and were also polite and considerate. They turned up when they said they would and cleared all mess behind them." },
  { name: "Willy Tang", text: "Had an excellent experience — it was just so easy to communicate with the team and everything went smoothly. I am literally coming back and asking for new jobs with them right now. After years, I can feel it is actually getting even better." },
  { name: "Brayden Luksa", text: "They attended my job within a 4 hour period of my call, and the staff members I spoke to were absolutely fantastic, keeping me updated with what was happening! I couldn't recommend them enough!" },
  { name: "Jaco Kok", text: "The team installed a leak detection unit and a power outlet for it afterwards. In both cases the staff was very friendly, professional and worked within the scheduled timeframe. The work is done to a high standard. Highly recommended." },
  { name: "C Sinclair", text: "Had a very easy, streamlined process. Our technician was knowledgeable and explained things clearly. Didn't try to add on unnecessary work or fees. Would recommend." },
];

export default function Reviews({ suburb }) {
  const featured = suburb ? REVIEWS[suburb.name.length % REVIEWS.length] : null;
  return (
    <section id="reviews" className="bg-white border-t-4 border-tpeco-ink py-16 sm:py-20 overflow-hidden" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal className="text-center flex flex-col items-center">
          <span className="chip-brutal bg-tpeco-blue border-tpeco-blue text-white">REAL GOOGLE REVIEWS</span>
          <h2 className="mt-4 font-display uppercase text-5xl sm:text-6xl leading-[0.95]" data-testid="reviews-heading">
            DON'T TAKE <span className="bg-tpeco-pink text-white px-3 rounded-2xl inline-block">OUR WORD</span> FOR IT
          </h2>
        </Reveal>
        {featured && (
          <Reveal i={1} className="mt-8 card-brutal !bg-tpeco-blue text-white p-6 sm:p-8 max-w-3xl" data-testid="featured-local-review">
            <span className="chip-brutal bg-white border-white text-tpeco-blue">{suburb.name.toUpperCase()} LOCALS, READ THIS ONE</span>
            <div className="mt-4 flex gap-1">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="w-5 h-5 text-amber-400 fill-amber-400" />
              ))}
            </div>
            <p className="mt-3 text-base sm:text-lg font-semibold text-white/95">"{featured.text}"</p>
            <p className="mt-4 font-display uppercase text-xl">{featured.name} · <span className="text-white/70 text-sm tracking-widest">FIVE-STAR GOOGLE REVIEW</span></p>
            <p className="mt-2 text-xs font-bold uppercase tracking-widest text-tpeco-pink">Same crew. Same standard. Servicing {suburb.name} daily.</p>
          </Reveal>
        )}
      </div>
      <div className="mt-10">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {REVIEWS.map((r, i) => (
            <article key={i} className="card-brutal w-[320px] sm:w-[360px] mx-3 p-5 whitespace-normal align-top text-center" data-testid={`review-card-${i}`}>
              <div className="flex gap-1 justify-center">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-amber-400 fill-amber-400" />
                ))}
              </div>
              <p className="mt-3 text-sm font-semibold text-neutral-700 line-clamp-5">"{r.text}"</p>
              <p className="mt-3 font-display uppercase text-lg">{r.name}</p>
              <p className="text-[11px] font-bold uppercase tracking-widest text-neutral-500">Five-star Google review</p>
            </article>
          ))}
        </Marquee>
      </div>
    </section>
  );
}
